import styled from 'styled-components';

export const HelpWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  /* padding: 5px 0; */
  .header {
    font-size: 32px;
    color: #565682;
    text-align: left;
  }

  .content {
    max-width: 800px;
    margin: 0 auto;
  }
  .ant-typography {
    margin: 0.5em 0;
  }
  .bottom-tips {
    margin: 100px 0;
    width: 100%;
    text-align: center;
    p {
      font-weight: bold;
    }
    p:last-child {
      font-weight: normal;
      padding-bottom: 20px;
    }
  }
`;
